import { Component, Inject, OnInit } from '@angular/core';
import { Index } from '@classes/index';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UiService } from 'app/core/services/ui.service';
import { IndexService } from 'app/core/services/index.service';

@Component({
  selector: 'app-index-detail',
  templateUrl: './index-detail.component.html',
  styleUrls: ['./index-detail.component.scss']
})
export class IndexDetailComponent implements OnInit {

  indexForm: FormGroup;
  masterIndex: Index | null;
  calculIndex: number;

  constructor(
    private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<IndexDetailComponent>,
    private indexService: IndexService,
    private uiService: UiService,
    @Inject(MAT_DIALOG_DATA) public data: Index
  ) { }

  ngOnInit() {
    this.getMasterIndex();
    this.initFormBuilder();
  }
  private initFormBuilder() {
    const fb = this.formBuilder;
    const indexForm = this.indexForm = fb.group({
      id: fb.control(this.data?.id),
      value: fb.control(this.data?.value, [Validators.required]),
      year: fb.control(this.data?.year, [Validators.required]),
    });

    this.calculIndex = (this.data?.value || 1) / (this.masterIndex?.value || 1);

    indexForm.controls.value.valueChanges.subscribe(value => {
      this.calculIndex = value / (this.masterIndex?.value || 1)
    })
  }

  getMasterIndex() {
    this.indexService.masterIndex.subscribe(value => this.masterIndex = value);
  }

  onSubmit() {
    const index = new Index(
      this.indexForm.value
    )
    this.uiService.addRouteLoading();
    this.indexService.createOrUpdateIndex(index).subscribe(data => {
      this.indexService.getCurrentIndex();
      this.dialogRef.close(true);
      this.uiService.displayMessageToast('index.success-edit');
      this.uiService.removeRouteLoading();
    }, error => {
      console.error(error);
      this.uiService.removeRouteLoading();
    })
  }

  onCancel() {
    this.dialogRef.close(false);
  }
}
